<!------------------------------------------------------------------------------
  Copyright (c) 2018. Keni Williams <kenneth.williams@estuk.co.uk>

  This file TeamVsTeam.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  TeamVsTeam.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<!------------------------------------------------------------------------------
 File: TeamVsTeam 
 Created by Keni Williams <kenneth.williams@estuk.co.uk>.
 with: IntelliJ IDEA
 Date: 19/10/2018
 Time: 15:59
------------------------------------------------------------------------------->
<template>
    <div class="row align-items-center no-gutters">
        <template>
            <div class="p-0 col-5">
                <img v-if="hasImage(team_a)" :src="makeUrl(team_a)"
                     class="p2"
                     :class="cls"
                     :alt="makeAlt(team_a)"
                     :title="makeAlt(team_a)"
                >
            </div>
            <div class="p-0 m-0 col-2 text-center">
                <span class="fs-13 text-body font-weight-bold m-0">vs</span>
            </div>
            <div class="p-0 col-5">
                <img v-if="hasImage(team_b)" :src="makeUrl(team_b)"
                     class="p2"
                     :class="cls"
                     :alt="makeAlt(team_b)"
                     :title="makeAlt(team_b)"
                >
            </div>
        </template>
    </div>
</template>

<script>
	import {IMAGE_URL_BASE, BUCKET_NAME, CDN_URL} from '../../config/config';
	import lang from '../../../../../app/Shared/Resources/Assets/js/helpers/lang'

	export default {
		name: "TeamVsTeam",
		components: {},
		props: {
			team_a: Object,
			team_b: Object,
			cls: String
		},
		created() {
		},
		destroyed() {
		},
		mounted() {

		},
		data() {
			return {}
		},
		methods: {
		    hasImage(team){
		        if(typeof team === 'undefined'){
		            return false;
                }
		        return team.hasOwnProperty('logo');
            },
            makeUrl(team) {
				return `${CDN_URL + '/' + BUCKET_NAME + '/' + IMAGE_URL_BASE.teams_url + team.logo.file_name}.${team.logo.ext}`
			},
			makeAlt(team) {
				return this.lang('title', team.lang)
			},
			lang(path, object) {
				// console.log('object',object);
				// return;
				return lang(path, object);
			}
		},
		watch: {},
		computed: {

        }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/teams/TeamVsTeam.vue